import {Form, Formik, FormikHelpers} from 'formik'
import MessageWindow from './MessageWindow'
import RecipientTypeSelection from './RecipientTypeSelection'
import * as Yup from 'yup'
import {MessagePayload, ReceiverType} from '../types'
import CustomDateRangePicker from '../../../../components/CustomDateRangePicker'
import {format} from 'date-fns'
import {useMessageMutation} from '../hooks/useMessageMutation'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {getCSSVariableValue} from '../../../../_metronic/assets/ts/_utils'

function NewChat() {
  const {sendMutation} = useMessageMutation()

  const handleSubmit = (
    values: MessagePayload,
    {setSubmitting, resetForm}: FormikHelpers<MessagePayload>
  ) => {
    sendMutation.mutate(values, {
      onSuccess: async () => {
        resetForm()
        setSubmitting(false)
      },
      onError: (error) => {
        setSubmitting(false)
      },
    })
  }

  const msgFormik = {
    initialValues: {
      messageType: 'information',
      senderId: 1,
      senderType: 'admin',
      templateType: 'common',
      content: '',
      studentIds: [],
      receiverType: 'all',
      class_Name: '',
      divisionName: '',
      dateFrom: '',
      dateTo: '',
    } as MessagePayload,
    onSubmit: handleSubmit,
    validationSchema: Yup.object({
      messageType: Yup.string()
        .oneOf(['information', 'acknowledgment'])
        .required('Message type is required'),
      content: Yup.string().required('Message content is required'),
      receiverType: Yup.string()
        .oneOf<ReceiverType>(['all', 'standard', 'specific'])
        .required('Receiver type is required'),
      studentIds: Yup.array().when('receiverType', {
        is: 'specific',
        then: (schema) =>
          schema.min(1, 'Select at least one student').required('Students are required'),
        otherwise: (schema) => schema.notRequired(),
      }),
      class_Name: Yup.string().when('receiverType', {
        is: 'standard',
        then: function (schema) {
          return schema.test(
            'class-or-division-check',
            'Class or Division required',
            function (value) {
              const {divisionName} = this.parent // Access sibling field
              return !!value || !!divisionName // Ensure one is provided
            }
          )
        },
        otherwise: (schema) => schema.notRequired(),
      }),
      divisionName: Yup.string().when('receiverType', {
        is: 'standard',
        then: function (schema) {
          return schema.test(
            'division-or-class-check',
            'Class or Division required',
            function (value) {
              const {class_Name} = this.parent // Access sibling field
              return !!value || !!class_Name // Ensure one is provided
            }
          )
        },
        otherwise: (schema) => schema.notRequired(),
      }),
      dateFrom: Yup.date().required('Start date is required'),
      dateTo: Yup.date().required('End date is required'),
    }),
  }
  return (
    <>
      <Formik
        initialValues={msgFormik.initialValues}
        onSubmit={msgFormik.onSubmit}
        validationSchema={msgFormik.validationSchema}
        validateOnChange={false}
        validateOnBlur={false}
        validateOnMount={false}
      >
        {({errors, values, setFieldValue}) => (
          <Form className="h-100 w-100 d-flex">
            <div
              style={{
                backgroundColor: 'rgb(245 243 255)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'end',
                width: '60%',
                backgroundImage:
                  'url(' + toAbsoluteUrl('/media/illustrations/sigma-1/16.png') + ')',
                backgroundPosition: 'center 90px',
                backgroundSize: '68%',
                backgroundRepeat: 'no-repeat',
                borderRight: '1px solid' + getCSSVariableValue('--bs-secondary'),
                borderLeft: '1px solid' + getCSSVariableValue('--bs-secondary'),
              }}
            >
              <MessageWindow />
            </div>
            <div className="bg-white rounded-end px-8 py-6 overflow-auto" style={{width: '40%'}}>
              <div>
                <div className="fs-5 text-gray-600 mb-2">Message Schedule</div>
                <CustomDateRangePicker
                  name="date"
                  value={[values.dateFrom, values.dateTo]}
                  onChange={(val: any) => {
                    if (val) {
                      setFieldValue('dateFrom', format(val[0], 'yyyy-MM-dd'))
                      setFieldValue('dateTo', format(val[1], 'yyyy-MM-dd'))
                    } else {
                      setFieldValue('dateFrom', '')
                      setFieldValue('dateTo', '')
                    }
                  }}
                  rangeDivider="to"
                  className={'border-bottom border-gray-300 pb-1 mb-7'}
                />
                {(errors.dateFrom || errors.dateTo) && (
                  <div className="text-sm text-danger mt-1">Schedule dates are required</div>
                )}
              </div>
              <RecipientTypeSelection />
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default NewChat
